import { render } from "./GameContainer.vue?vue&type=template&id=be7cdf86"
import script from "./GameContainer.vue?vue&type=script&lang=js"
export * from "./GameContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__